import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TEMPLATE_TYPE_SMS } from './customer-facing.service';

@Component({
  selector: 'app-confirm-customer-form-dialog',
  styleUrls: ['./confirm-dialog.component.scss'],
  templateUrl: './confirm-dialog.component.html',
  standalone: false,
})
export class ConfirmCustomerFormDialogComponent {
  readonly TEMPLATE_TYPE_SMS = TEMPLATE_TYPE_SMS;
  templateType: string;
  constructor(
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<ConfirmCustomerFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { templateType: string },
  ) {
    this.templateType = data.templateType;
  }
}
